import React from "react";
import {
  Container,
  Typography,
} from "@material-ui/core";

import {
  LocalShippingOutlined,
  LocalOfferOutlined,
  ReplayOutlined,
  SecurityOutlined,
} from "@material-ui/icons";

const features = [
  {
    icon: <LocalShippingOutlined />,
    title: "Free Shipping",
    description: "Free Ship Over $150",
  },
  {
    icon: <LocalOfferOutlined />,
    title: "Best Deal Online",
    description: "We provide a free in-home.",
  },
  {
    icon: <ReplayOutlined />,
    title: "15 Days Return",
    description:
      "We provide a free in-home measure.",
  },
  {
    icon: <SecurityOutlined />,
    title: "Secure Payment",
    description: "We provide a free in-home.",
  },
];

const FeatureStrip: React.FC = () => {
  return (
    <div className="feature-section">
      <Container maxWidth="lg">
        <div className="feature-grid">
          {features.map((feature) => (
            <div
              className="feature-item"
              key={feature.title}
            >
              <div className="feature-icon">
                {feature.icon}
              </div>

              <div>
                <Typography className="feature-title">
                  {feature.title}
                </Typography>

                <Typography className="feature-description">
                  {feature.description}
                </Typography>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
};

export default FeatureStrip;